/**
 * Region / branch mapping — shared across features (payroll, staff, ...).
 *
 * Regions are derived from the branch tree, not hardcoded: a region a director
 * creates must appear without a code change. `regionOfBranch` stays a pure
 * function so non-React callers (payroll math) can use it; pass the units in,
 * or use `useRegionOfBranch()` in components to get it pre-bound.
 */

import { FALLBACK_REGIONS } from "./branches/fallback";
import { ALL_REGION, type Region, type TreeUnit, regionOfBranchIn } from "./branches/tree";

export type { Region, TreeUnit };

/**
 * Static region list.
 *
 * @deprecated Use `useRegions()`, which derives regions from the catalog. This
 * cannot see a region created after build time.
 */
export const REGIONS = [ALL_REGION, ...FALLBACK_REGIONS] as const;

export type RegionKey = string;

/**
 * Maps a staff `branch` into a region key.
 *
 * Always pass `units`. Without them a branch under a newly created group falls
 * through to "all", which quietly files that region's staff under Toàn quốc —
 * no error, just wrong numbers.
 */
export function regionOfBranch(
  branch: string | null | undefined,
  units?: readonly TreeUnit[],
): RegionKey {
  return regionOfBranchIn(branch, units ?? []);
}
